import { useMemo, useState } from "react";
import { useDayPicker, useNavigation } from "react-day-picker";
import { setYear, startOfYear, startOfMonth } from "date-fns";
import { DatePickerYearSelectRoot } from "./DatePickerYearSelect.styles";
import { SelectOption } from "@commonlibs";

export interface DatePickerYearSelectProps {
    className?: string;
    style?: React.CSSProperties;
}

function DatePickerYearSelect({ className }: DatePickerYearSelectProps) {
    //Hooks
    const { fromDate, toDate } = useDayPicker();
    const { goToMonth, currentMonth } = useNavigation();
    const [currentYear, setCurrentYear] = useState<number>(currentMonth.getFullYear());

    //Handlers
    function handleChange(value: number) {
        setCurrentYear(value);
        const newMonth = setYear(startOfMonth(currentMonth), value);
        goToMonth(newMonth);
    }

    //Variables
    const fromYear = fromDate?.getFullYear();
    const toYear = toDate?.getFullYear();

    const yearOptions: SelectOption<number>[] = useMemo(() => {
        const years: SelectOption<number>[] = [];

        if (!fromYear || !toYear) return years;

        for (let year = fromYear; year <= toYear; year++) {
            const newYear = setYear(startOfYear(new Date()), year).getFullYear();
            years.push({ label: newYear.toString(), value: newYear });
        }

        return years;
    }, [fromYear, toYear]);

    const renderSelect = yearOptions.length > 1;

    return (
        <>
            {renderSelect && (
                <DatePickerYearSelectRoot
                    value={currentYear}
                    onChange={handleChange}
                    renderValue={() => <></>}
                    className={className}
                    options={yearOptions}
                />
            )}
        </>
    );
}

export default DatePickerYearSelect;
